<template>
    <div class="templete">
        <!-- <div class="tabs">
            <div style="position: relative;left: -15px;" class="item" :class="item.id == target?'active': ''" v-for="(item) in dataTemplate" :key="item.key" @click="choose(item)">
                {{ item.name }}
            </div>
            <i class="operation_add" @click="addTemplate" title="新增"></i>
            <i class="operation_delete" @click="detailTemplate" title="删除"></i>
        </div> -->
    <div class="printSetBox clearfix">
        <div class="left">
            <div class="path">
                <span class="title">表单字段自定义配置</span>
            </div>
            <div class="group">
                <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in keyList" :key="item.key" @click="check(item,1)">
                    {{ item.name }}
                </div>
                <el-checkbox class="check_all_item" v-model="is_all" @change="checkAll($event,1)">全选</el-checkbox>
            </div>
            <div class="path">
                <span class="title">品名选择内容</span>
            </div>
            <div class="group">
                <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in breedList" :key="item.key" @click="check(item,3)">
                    {{ item.name }}
                </div>
            </div>
            <div class="path" style="margin-top:20px;">
                <span class="title">表单信息自定义配置</span>
            </div>
            <div class="group">
                <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in detailConfig" :key="item.key" @click="check(item,2)">
                    {{ item.name }}
                </div>
                <el-checkbox class="check_all_item" v-model="is_allDetail" @change="checkAll($event,2)">全选</el-checkbox>
            </div>
            <div class="path" style="margin-top:20px;">
                <span class="title">标题自定义</span>
            </div>
            <el-input class="companyName" v-model="inputs[0].value" @blur="confirmSetConfig"></el-input>
            <div class="path" style="margin-top:20px;">
                <span class="title">票据联自定义</span>
            </div>
            <el-input class="companyName" v-model="inputs[1].value" @blur="confirmSetConfig"></el-input>
            <div class="path" style="margin-top:20px;">
                <span class="title">打印行数</span>
            </div>
            <el-input class="companyName" v-model="inputs[2].value" @blur="confirmSetConfig"></el-input>
            <div class="lawEditBox">
                <section class="gradeSection">
                    <div class="path">
                        <span class="title">送货单条款</span>
                        <div class="">
                            <i class="el-icon-refresh" @click="getList(1)"></i>
                            <el-button type="danger" @click="addDialogVisible=!addDialogVisible;type=2;" size="mini">新增</el-button>
                        </div>
                    </div>
                    <div class="table_path">
                        <el-table :data="law" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                            <el-table-column label="操作" width="70">
                                <template slot-scope="scope">
                                    <div class="icon_wrap">
                                        <i class="operation_edit" @click="edit(scope.row.id)" title="修改"></i>
                                        <i class="operation_delete" @click="del(scope.row.id)" title="删除"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="条款内容" prop="content" show-overflow-tooltip></el-table-column>
                            <el-table-column label="顺序排列" width="100">
                                <template slot-scope="scope">
                                    <div class="lawup" @click="changeStatus(scope.row.id,1)"></div>
                                    <div class="lawdown" @click="changeStatus(scope.row.id,0)"></div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </section>
            </div>
        </div>
        <div class="right">
            <div class="path">
                <span class="title">配置预览</span>
            </div>
            <div class="rightBox">
                <div class="print_templete">
                    <div class="print_templeteTable">
                        <div class="logoprint"></div>
                        <div class="companyTitle">{{companyTitle}}</div>
                        <div class="order_serial" v-if="flagConfig.order_serial">{{"20-07-15-0090"}}</div>
                        <!-- <div class="title">{{"送货单"}}</div> -->
                        <div class="tablePerson clearfix">
                            <div class="personBox">
                                <div class="person" v-if="flagConfig.receiver">收货单位：{{'测试名称'}}</div>
                                <div class="person" v-if="flagConfig.address">客户地址：{{'测试地址'}}</div>
                            </div>
                            <div class="personBox">
                                <div class="person" v-if="flagConfig.order_sn">送货单号：{{'测试名称'}}</div>
                                <div class="person" v-if="flagConfig.date">送货日期：{{'2020-01-01'}}</div>
                            </div>
                        </div>
                        <div class="tableBox">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <td style="width:50px;">序号</td>
                                        <td  v-for="(list,index) in keyList" :key="index" v-show="list.show">{{list.name}}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(list,index) in listDetail" :key="index">
                                        <td style="width:50px;">{{index+1}}</td>
                                        <td v-for="(item,key,ind) in list" :key="ind">{{item}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="remarkBox" v-if="flagConfig.remark">
                                <div class="remarkTextarea"></div>
                            </div>
                            <div class="truck_remarkBox" v-if="flagConfig.truck_remark">
                                <div class="remarkTextarea"></div>
                            </div>
                            <div class="law" v-if="flagConfig.treaty">
                                <div class="lawTextFu">附</div>
                                <div class="lawText" v-for="(item,index) in law" :key="index">{{(index+1) +'. '+item.content}}</div>
                            </div>
                            <div class="bottom clearfix">
                                <div class="bottomMessC clearfix">
                                    <div class="bottomMess" v-if="flagConfig.info_line">制单人：</div>
                                    <div class="bottomMess" v-if="flagConfig.shipper">发货单位：测试名称</div>
                                    <div class="bottomMess" v-if="flagConfig.shipper">公司地址：测试地址</div>
                                    <div class="bottomMess" v-if="flagConfig.shipper">销售人：测试名称</div>
                                    <div class="bottomMess" v-if="flagConfig.shipper">电话：88888888888</div>
                                </div>
                                <div class="bottomMessC clearfix">
                                    <div class="bottomMess" v-if="flagConfig.info_line">收货单位签字(盖章)</div>
                                    <div class="bottomMess"></div>
                                    <div class="bottomMess"></div>
                                    <div class="bottomMess" v-if="flagConfig.driver">司机签字：</div>
                                </div>
                                <div class="bottomMessC clearfix">
                                    <div class="bottomMess" v-if="flagConfig.info_line">出货单位签字(盖章)</div>
                                    <div class="bottomMess" v-if="flagConfig.receiver_sign">收货单位：</div>
                                    <div class="bottomMess" v-if="flagConfig.receiver_sign">收货人签字（盖章）：</div>
                                    <div class="bottomMess" v-if="flagConfig.receiver_sign">电话：</div>
                                    <!-- <div class="bottomMess" v-if="flagConfig.demander">收货单位：谱木科技</div> -->
                                </div>
                            </div>
                        </div>
                        <div class="printLian">{{union_pager}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!--条款添加 START-->
        <el-dialog v-dialog-drag title="送货单条款" :visible.sync="addDialogVisible" width="500px" class="eldialog eldialogA" :model="false">
            <div class="titlelaw">条款内容</div>
            <textarea class="edit_input edit_textarea" v-model="lawContent.content" placeholder="条款内容"></textarea>
            <div class="dialogBtnList clearfix">
                <el-button class="publicBtn dialogBtn"  @click="confirm(1)">保存</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="confirm(2)">保存并新增</el-button>
            </div>
		</el-dialog>
        <!--条款添加 END-->
    </div>
        <el-dialog v-dialog-drag title="新增打印模板" :visible.sync="addTemplateVisible" width="400px" class="eldialog eldialogB" :model="false"    >
           <el-form  class="dialogFormB clearfix" style="padding-bottom: 20px;">
                <div class="eldialogSetPriceBox clearfix" >
                    <el-form-item  label="模板名称:">
                        <el-input class="a"  v-model="templateName" placeholder="输入内容"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="publicBtn dialogBtn" @click="addTemplateOk">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="addTemplateVisible=!addTemplateVisible">取消</el-button>
            </div>
        </el-dialog>
        <!-- 删除打印模板 -->
        <el-dialog v-dialog-drag title="删除打印模板" :visible.sync="detailTemplateVisible" width="400px" class="eldialog eldialogB" :model="false"    >
           <el-form  class="dialogFormB clearfix" style="padding-bottom: 20px;">
                <div class="eldialogSetPriceBox clearfix" style="text-align: center;">
                    <span>是否确认删除打印模板~!</span>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="publicBtn dialogBtn" @click="detailTemplateOk">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="detailTemplateVisible=!detailTemplateVisible">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .container{
            padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
        }
        .tabs{
            display: flex; align-items: center; margin-bottom: 23px;
            .item {border-radius: 3px;
                font-size:14px; color: #333333; cursor: pointer; border: 1px solid #333333; padding: 5px 15px;
                &.active{ border: 1px solid #B21111;background-color: #B21111;color:#fff;}
            }
            .item + .item{ margin-left: 30px; }
        }
    .companyName /deep/ .el-input__inner{line-height: 25px;height:25px;font-size: 12px;}
    .companyName /deep/ .el-input__inner:focus{border-color:#b21111;}
    .tableBox{display: block;}
    .logoprint{width:130px;height:30px;background: url('../../assets/logoPrint.png') no-repeat 100% 100%;background-size: contain;position: absolute;top:0;left:0;}
    .blankMess td{font-size: 12px;border:1px solid #777;width:50%;padding:3px 10px;}
    .blankMess{border-collapse:collapse;width:100%;margin-top:10px; }
    .law{padding-top:10px;padding-left:20px;position: relative;}
    .lawTextFu{position: absolute;top:10px;left:0;font-size:12px;}
    .lawText{font-size: 12px;margin-bottom:5px;text-align: left; }
    .print_templete{position: relative;}
    .print_templete .title{font-size: 16px;font-weight: 600;padding-bottom:20px;text-align: center;}
    .print_templete .companyTitle{font-size: 20px;font-weight: 600;padding-bottom:15px;text-align: center;}
    // .print_templete .tablePerson{}
    .print_templete .personBox{float: left;}
    .print_templete .personBox:nth-child(2n){float: right;}
    .print_templete .personBox .person{text-align: left;}
    .print_templete .personBox:nth-child(2n) .person{text-align: right;}
    .print_templete .person{font-size: 12px;}
    // .print_templete .tableBox{}
    .print_templete .table{width:100%;border-collapse:collapse;text-align: center;}
    .print_templete .table td{border:1px solid #777;font-size: 12px;padding:5px 0;}
    .print_templete .remarkBox{width:100%;border:1px solid #777;border-top:0;box-sizing: border-box;padding:5px 5px 5px 40px;position: relative;}
    .print_templete .remarkBox:before{content:"备注:";position: absolute;font-size: 12px;color: #000;top:7px;left:5px;}
    .print_templete .remarkBox .remarkTextarea{width:100%;border:0;color:#000;height:22px;text-align: left;font-size: 12px;padding:3px 0;}
    .print_templete .truck_remarkBox{width:100%;border:1px solid #777;border-top:0;box-sizing: border-box;padding:5px 5px 5px 40px;position: relative;}
    .print_templete .truck_remarkBox:before{content:"车牌备注:";position: absolute;font-size: 12px;color: #000;top:7px;left:5px;font-weight: 600;}
    .print_templete .truck_remarkBox .remarkTextarea{width:100%;border:0;color:#000;height:22px;text-align: left;font-size: 12px;padding:3px 0;}
    // .print_templete .bottom{}
    .print_templete .bottomMess{font-size: 12px;padding:5px 0;text-align: left;}
    .print_templete .bottomMessC{width:40%;float: left;}
    .print_templete .bottomMessC:nth-child(2n){float: left;width:30%;}
    .print_templete .bottomMessC:nth-child(3n){float: right;width:150px;}
    .order_serial{font-size: 12px;position: absolute;top:10px;right:0;}
    // .print_templete .bottomMessC:nth-child(2n) .bottomMess{}
    // .print_templete .bottomMess:nth-child(1){text-align: left;}
    // .print_templete .bottomMess:nth-child(2){text-align: center;}
    // .print_templete .bottomMess:nth-child(3){text-align: right;}


    .lawEditBox{margin-top:20px;height:400px;}
    .gradeSection{display: flex;flex-direction: column;height:100%;}
    .titlelaw{font-size: 13px;font-weight: 700;color:#333;margin-bottom:10px;}
    .lawup{width:15px;height:15px;background: url(/icon/lawup.png) no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;float: left;margin-right:10px;}
    .lawdown{width:15px;height:15px;background: url(/icon/lawdown.png) no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;float: left;}
    .eldialogA .dialogBtnList{padding-right:0;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .tab{
        display: flex; align-items: center; font-size:16px; color:rgba(51,51,51,1);
        .item{
            border-bottom: 3px solid transparent; padding:4px; cursor: pointer;
            &.active{ border-color: #B21111}
        }
        .item + .item{ margin-left: 75px}
    }
    .group{
        display: flex; flex-wrap: wrap;
        .item{ min-width:85px; height:36px; line-height: 32px; text-align: center; padding: 0 12px; border-radius:3px; border:1px solid rgba(102,102,102,1); cursor: pointer; margin: 6px; }
        .item.checked{
            border:1px solid rgba(178,17,17,1); position: relative; color: #B21111;
            &::after{ display: block; content: ""; width:21px; height:21px; position: absolute; right: 0; bottom: 0; background: url("/icon/checkeded.png") no-repeat; background-size: cover; }
        }
        .check_all_item{ height:36px; line-height: 36px; text-align: center; margin: 6px; }
    }
    .flex_1{ flex: 1; }
    .img-info{
        table{
            border-collapse: collapse; white-space: nowrap; font-size: 14px; text-align: center;
            td{ height:42px; }
            .col{ width:100px; height:42px; }
            .col_1{ width:168px; background:rgba(178,17,17,1); color: #fff; }
        }
    }
    .printSetBox{padding-right:600px;box-sizing: border-box;position: relative;}
    .blue{ color: rgb(21, 91, 212); cursor: pointer; }
    // .left{}
    .rightBox{padding:20px;box-sizing: border-box;background-color: F6F7FB;}
    .right{width:550px;height:650px;margin-left:50px;position: absolute;top:0;right:0;}
    // F6F7FB
    
</style>
<script>
    export default {
        data(){
            return{
                companyName:localStorage.dw_erp_company_name,
                is_all : true,
                is_allDetail:true,
                keyList : [],
                listDetail:[],
                breedList:[],
                law:[],
                lawContent:{
                    category:1,
                    template_id:0,
                    content:""
                },
                detailConfig:[],
                flagConfig:{},
                addDialogVisible:false,
                type:2,//2.新增 3.修改
                inputs:[
                    {value:""},
                    {value:""},
                    {value:""}
                ],
                companyTitle:"",
                union_pager:"",
                dataTemplate:[],
                addTemplateVisible:false,
                templateName:"",
                detailTemplateVisible:false,
                target:0,
            }
        },
        created(){
            this.getList()
            this.getPrintSet()
            this.print()
        },
        methods:{
            print(){
                this.postFunc("/erp/print.template.get",{category:0},res=>{
                    this.dataTemplate = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            addTemplateOk(){
                this.postFunc("/erp/print.template.add",{category:0,name:this.templateName},res=>{
                    this.tip("新增成功","success")
                    this.print()
                    this.addTemplateVisible =false
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            detailTemplateOk(){
                if(this.target==0){
                    this.tip('默认模板不可删除','warning')
                }else{
                    this.postFunc("/erp/print.template.delete",{id:this.target},res=>{
                        this.tip("删除成功","success")
                        this.print()
                        this.target=0;
                        this.detailTemplateVisible =false
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            changeStatus(id,type){
                this.postFunc("/erp/treaty.order",{id:id,is_up:type},()=>{
                    this.getList()
                    if(type==1){
                        this.tip("上移成功","success")
                    }else{
                        this.tip("下移成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            confirm(type){
                let url="";
                if(this.type==2){
                    url="/erp/treaty.create";
                }else if(this.type==3){
                    url="/erp/treaty.update";
                }
                this.lawContent.template_id =this.target;
                this.postFunc(url,this.lawContent,()=>{
                    this.getList()
                    this.tip("操作成功","success")
                    if(type==1){
                        this.addDialogVisible = false;
                    }else if(type==2){
                        this.lawContent.content = "";
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            edit(id){
                this.law.forEach(item=>{
                    if(item.id==id){
                        this.lawContent = JSON.parse(JSON.stringify(item));
                    }
                })
                this.type=3;
                this.addDialogVisible=true;
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/treaty.delete",{id:id},()=>{
                        this.getList()
                        this.tip("删除成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            confirmSetConfig(){
                this.postFunc("/erp/print.set.update",{category:1,template_id:this.target,fields:this.detailConfig,column:this.keyList,inputs:this.inputs,select_breed:this.breedList},()=>{
                    this.getPrintSet()
                    this.tip("修改成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            checkIsAllChecked(){
                let flag = true;
                let flagDetail = true;
                this.keyList.forEach((item)=>{
                    if(!item.show){
                        flag = false;
                    }
                })
                if(flag){
                    this.is_all = true;
                }else{
                    this.is_all = false;
                }
                this.detailConfig.forEach((item)=>{
                    if(!item.show){
                        flagDetail = false;
                    }
                })
                if(flagDetail){
                    this.is_allDetail = true;
                }else{
                    this.is_allDetail = false;
                }
            },
            getPrintSet(){
                this.postFunc("/erp/print.set.get",{"category": 1,template_id:this.target},res=>{
                    this.keyList = res.data.data.column;
                    this.detailConfig = res.data.data.fields;
                    this.breedList = res.data.data.select_breed;
                    this.inputs = res.data.data.inputs;
                    this.companyTitle = this.inputs[0].value;
                    this.union_pager = this.inputs[1].value;
                    let obj = new Object();
                    this.keyList.forEach(item=>{
                        if(item.show){
                            let valObj = new Object();
                            // valObj[item.key] = parseInt(Math.random()*100);
                            valObj[item.key] = "    ";
                            Object.assign(obj,valObj)
                        }
                    })
                    this.listDetail = [obj,obj,obj]
                    // let detailObj = new Object();
                    this.detailConfig.forEach(item=>{
                        let valObj = new Object();
                        valObj[item.key] = item.show;
                        Object.assign(this.flagConfig,valObj)
                    })
                    this.checkIsAllChecked()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getList(showMessage){
                this.postFunc("/erp/treaty.list",{"category": 1,template_id:this.target},res=>{
                    this.law = res.data.data;
                    if(showMessage){
                        this.tip("刷新成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //新增模板
            addTemplate(){
                this.addTemplateVisible = true
            },
            detailTemplate(){
                if(this.target==0){
                    this.tip("默认模板不可删除","warning")
                }else{
                    this.detailTemplateVisible = true
                }
            },
            choose(row){
                this.target = row.id;
                this.getPrintSet()
                this.getList()
            },
            check(row,type){
                let flag = true;
                if(type==1){
                    this.keyList.forEach((item,index)=>{
                        if(item.key==row.key){
                            this.keyList[index].show = !item.show;
                        }
                        if(!item.show){
                            flag = false;
                        }
                    })
                    if(flag){
                        this.is_all = true;
                    }else{
                        this.is_all = false;
                    }
                }else if(type==3){
                    this.breedList.forEach((item,index)=>{
                        if(item.key==row.key){
                            this.breedList[index].show = !item.show;
                        }
                        else{
                            this.breedList[index].show = !item.show;
                        }
                        console.log(item)
                        if(!item.show){
                            flag = false;
                        }
                    })
                }else{
                    this.detailConfig.forEach((item,index)=>{
                        if(item.key==row.key){
                            this.detailConfig[index].show = !item.show;
                        }
                        if(!item.show){
                            flag = false;
                        }
                    })
                    if(flag){
                        this.is_allDetail = true;
                    }else{
                        this.is_allDetail = false;
                    }
                }
                this.confirmSetConfig()
            },
            checkAll(value,type){
                if(type==1){
                    this.keyList.forEach((item,index)=>{
                        this.keyList[index].show = value;
                    })
                }else if(type==3){
                    this.breedList.forEach((item,index)=>{
                        this.breedList[index].show = value;
                    })
                }else{
                    this.detailConfig.forEach((item,index)=>{
                        this.detailConfig[index].show = value;
                    })
                }
                this.confirmSetConfig()
            }
        },
        watch:{
            addDialogVisible:function(val){
                if(!val){
                    delete this.lawContent.id;
                    this.lawContent.category = 1;
                    this.lawContent.content = "";
                }
            }
        }
    }
</script>
